import { DefinitionDto } from "app/modules/shared/model/definition.dto";

export class UnitsDto extends DefinitionDto {}
